<template>
    <el-menu mode="horizontal" class="sp-client-header"
             :ellipsis="($root.screenSize < $root.ellipsisNavbarScreenMaxSize)">
        <el-menu-item index="0" class="menu-item-logo">
            <div style="background-color:var(--enea-color-darkblue);width:200px;text-align:center;margin-left:-30px;height:60px;">
                <router-link to="/" style="display:block;margin-left:0px;padding-left:12px;padding-bottom:8px;">
                    <el-image v-if="!this.isDemo" :src="require('@/assets/images/Enea.logo.png')" />
                    <el-image v-if="this.isDemo" :src="require('@/assets/images/Sapico.logo.white.png')" />
                    <!-- <el-image class="sp-client-header-logo-white" :src="require('@/assets/images/Enea.logo.png')" />
                    <el-image class="sp-client-header-logo-darkblue" :src="require('@/assets/images/enea.logo.dark.png')" /> -->
                </router-link>
            </div>
        </el-menu-item>

        <el-menu-item index="1">
            <span v-if="!this.isDemo" class="sp-client-header-navbar-title">
                <span>{{ t('headers.NavbarTitleBegin') }}</span>
                <span class="sp-client-header-navbar-subtitle-big"> - {{ t('headers.NavbarTitle') }}</span>
                <br class="sp-client-header-navbar-subtitle-small" />
                <span class="sp-client-header-navbar-subtitle-small"
                      style="font-size:12px;line-height:12px;float:left;">{{ t('headers.NavbarTitle') }}</span>
            </span>
            <span v-if="this.isDemo" class="sp-client-header-navbar-title">
                <span>SAPICO</span>
                <span class="sp-client-header-navbar-subtitle-big"> - {{ t('headers.NavbarTitleDEMO') }}</span>
                <br class="sp-client-header-navbar-subtitle-small" />
                <span class="sp-client-header-navbar-subtitle-small"
                      style="font-size:12px;line-height:12px;float:left;">{{ t('headers.NavbarTitleDEMO') }}</span>
            </span>
        </el-menu-item>

        <div class="flex-grow"></div>

        <el-menu-item index="1" class="menu-hamburger">
            <a v-on:click="appvue.toggleCollapse()"><span class="mdi mdi-menu"></span></a>
        </el-menu-item>

        <!-- <el-menu-item index="changeTheme" v-if="this.isDemo">
            <template #title>
                <el-popover :width="300" trigger="click"
                    popper-style="box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;">
                    <template #reference>
                        <span class="mdi mdi-cog" style="font-size:28px;"></span>
                    </template>
                    <template #default>
                        <ThemeSettings></ThemeSettings>
                    </template>
                </el-popover>
            </template>
        </el-menu-item> -->

        <el-menu-item index="6" class="sp-header-badge hidden-xxs-only">
            <el-badge :value="$root.messageCounter" :max="99" class="item" v-on:click="$root.drawer = !$root.drawer;">
                <span class="mdi mdi-comment-outline" style="font-size:28px;"></span>
            </el-badge>
        </el-menu-item>

        <el-sub-menu index="3" class="sp-client-header-language hidden-xxs-only">
            <template #title>
                <el-avatar v-if="this.$i18n.locale == 'pl-PL'" fit="cover" size="small"
                           :src="require('@/assets/images/Languages/pl-PL.png')" />
                <el-avatar v-if="!this.$i18n.locale || this.$i18n.locale == 'en-GB'" fit="cover" size="small"
                           :src="require('@/assets/images/Languages/en-GB.png')" />
            </template>
            <el-menu-item index="3-1" v-on:click="appvue.setPL">Polski (pl-PL)</el-menu-item>
            <el-menu-item index="3-2" v-on:click="appvue.setEN">English (en-GB)</el-menu-item>
        </el-sub-menu>

        <el-menu-item index="4" class="sp-client-header-user hidden-xxs-only">
            <template #title>
                <el-popover :width="300" trigger="click"
                            popper-style="box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;">
                    <template #reference>
                        <span id="user_initials" v-if="initials" class="sp-client-header-user-initials fade">
                            {{ initials }}
                        </span>
                        <span v-else class="sp-client-header-user-initials" style="background-color: #bbb;">
                            <span class="mdi mdi-login"></span>
                        </span>
                    </template>
                    <template #default>
                        <el-row>
                            <el-col :lg="24" :md="24" :sm="24">
                                <div v-if="$root.user.name" style="text-align:center;font-size: 22px;">
                                    {{ $root.user.name }}
                                </div>
                            </el-col>
                        </el-row>

                        <el-divider></el-divider>

                        <div v-if="$root.user.isAuthenticated">
                            <el-row>
                                <el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="12">
                                    <el-button type="warning" @click="$root.changePassword">
                                        {{ t('toolbar.changePassword') }}
                                    </el-button>
                                </el-col>
                                <el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="12">
                                    <el-button type="primary" @click="$root.logoutUser" class="pull-right">
                                        {{ t('toolbar.logout') }}
                                    </el-button>
                                </el-col>
                            </el-row>
                        </div>

                        <div v-if="!$root.user.isAuthenticated">
                            <el-button type="primary" @click="$root.loginUser">
                                {{ t('toolbar.login') }}
                            </el-button>
                        </div>

                        <el-row v-if="timeLeftAccess <= this.sessionTimeoutInfo">
                            <el-col style="text-align:center;padding-top:8px;">
                                <div v-if="this.timeLeftAccess > 0">
                                    {{ t('messages.SessionWillBeExpired') }} <strong>{{ formattedTimeAccess }}</strong>
                                </div>
                                <div v-else>
                                    {{ t('messages.SessionExpired') }}
                                </div>
                            </el-col>
                        </el-row>

                    </template>
                </el-popover>
            </template>
        </el-menu-item>

    </el-menu>
</template>

<script>
    import $ from 'jquery'
    import ThemeSettings from '@/components/ThemeSettings.vue'
    import { t } from '@/setup/i18n-setup'
    import EventBus from '@/scripts/eventbus';
    import { mapActions, mapState } from 'pinia';
    import { useAccountStore } from '../stores/AccountStore'

    export default {
        name: 'HeaderMenu',
        inject: ['settings'],
        props: ['appvue'],
        computed: {
            ...mapState(useAccountStore, ['user', 'initials']),
            isDemo() {
                return this.settings.ENVIRONMENT == "DEMO";
            },
            formattedTime() {
                const minutes = Math.floor(this.timeLeft / 60);
                const seconds = this.timeLeft % 60;
                return `${minutes}m ${seconds < 10 ? '0' : ''}${seconds}s`;
            },
            formattedTimeAccess() {
                const minutes = Math.floor(this.timeLeftAccess / 60);
                const seconds = this.timeLeftAccess % 60;
                return `${minutes}m ${seconds < 10 ? '0' : ''}${seconds}s`;
            },
        },
        data() {
            return {
                timeLeft: 0,
                timeLeftAccess: 0,
                intervalId: null,
                sessionTimeoutInfo: 30, //s do pojawienia się ostrzeżenia
            }
        },
        created() {
            EventBus.on('tokenRefreshed', this.updateTimeLeft);
        },
        beforeUnmount() {
            EventBus.off('tokenRefreshed', this.updateTimeLeft);
        },
        mounted() {
            this.updateTimeLeft();
            this.intervalId = setInterval(() => {
                this.updateTimeLeft();
            }, 1000);
        },
        beforeDestroy() {
            clearInterval(this.intervalId);
        },
        methods: {
            t,
            updateTimeLeft() {
                const now = Date.now();
                const expiry = this.user.refreshExpirationDate;
                if (expiry) {
                    const expiryDate = new Date(expiry);
                    const diffMs = expiryDate.getTime() - now;

                    this.timeLeft = Math.max(Math.floor(diffMs / 1000), 0);
                } else {
                    this.timeLeft = 0;
                }

                const expiryAccess = this.user.accessExpirationDate;
                if (expiryAccess) {
                    const expiryAccessDate = new Date(expiryAccess);
                    const diffMs = expiryAccessDate.getTime() - now;

                    this.timeLeftAccess = Math.max(Math.floor(diffMs / 1000), 0);
                } else {
                    this.timeLeftAccess = 0;
                }
            },
        },
        watch: {
            timeLeftAccess: function (val) {
                if (val <= this.sessionTimeoutInfo) {
                    if (val % 2 === 0) {
                        $('#user_initials').addClass('initials_off');
                    }
                    else {
                        $('#user_initials').removeClass('initials_off');
                    };
                }
            },
        },
        components: {
            ThemeSettings,
        },
    }
</script>
